import { useEffect } from "react";
import { useI18n, useT } from "../i18n/I18nProvider";

const SITE_URL = "https://mysteriousstew.com";

const setMeta = (selector, attr, content) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, content);
};

/** Updates document title + description/OG tags per page and language. Renders nothing. */
export const Seo = ({ page, titleOverride, descriptionOverride }) => {
  const { lang } = useI18n();
  const t = useT();

  useEffect(() => {
    const title = titleOverride || t(`seo.${page}.title`);
    const description = descriptionOverride || t(`seo.${page}.description`);
    const url = `${SITE_URL}${window.location.pathname}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
  }, [page, titleOverride, descriptionOverride, lang, t]);

  return null;
};
